import type { Format } from './format'

/** A board keeps what lies on it in item rows; its identity body stays empty. */
export const board = {
  bodyStorage: 'rows',
  validate: (body: string) => body === '',
  outline: () => [],
  searchText: () => '',
  tools: [],
} as const satisfies Format
